import React from 'react';
import { CheckCircle, Ban, Edit, Trash2 } from 'lucide-react';
import { Card, CardContent } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';
import { Button } from '../../../components/ui/button';

export const DoctorList = ({ doctors, filteredDoctors, getStatusBadge, handleStatusChange, openEditDialog, setSelectedDoctor, setShowDeleteDialog }) => (
      <Card>
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full" data-testid="doctors-table">
              <thead className="bg-gray-50 border-b">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Doctor</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Specialization</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Experience</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Location</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Status</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {filteredDoctors.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="px-4 py-8 text-center text-gray-500">
                      No doctors found
                    </td>
                  </tr>
                ) : (
                  filteredDoctors.map((doctor) => (
                    <tr key={doctor._id} className="hover:bg-gray-50" data-testid={`doctor-row-${doctor._id}`}>
                      <td className="px-4 py-4">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                            <span className="text-purple-600 font-semibold">
                              {(doctor.full_name || 'D')[0].toUpperCase()}
                            </span>
                          </div>
                          <div>
                            <p className="font-medium text-gray-900">{doctor.full_name || 'N/A'}</p>
                            <p className="text-sm text-gray-500">{doctor.email}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-4">
                        <span className="text-sm text-gray-900">{doctor.specialization || 'N/A'}</span>
                      </td>
                      <td className="px-4 py-4">
                        <span className="text-sm text-gray-900">{doctor.experience_years ? `${doctor.experience_years} years` : 'N/A'}</span>
                      </td>
                      <td className="px-4 py-4">
                        <span className="text-sm text-gray-900">{doctor.city || 'N/A'}{doctor.state ? `, ${doctor.state}` : ''}</span>
                      </td>
                      <td className="px-4 py-4">
                        <Badge className={getStatusBadge(doctor.account_status)}>
                          {doctor.account_status || 'pending'}
                        </Badge>
                      </td>
                      <td className="px-4 py-4">
                        <div className="flex items-center gap-2">
                          <Button variant="ghost" size="sm" onClick={() => openEditDialog(doctor)} data-testid={`edit-doctor-${doctor._id}`}>
                            <Edit className="w-4 h-4" />
                          </Button>
                          {doctor.account_status !== 'verified' && (
                            <Button variant="ghost" size="sm" onClick={() => handleStatusChange(doctor._id, 'verified')} className="text-green-600">
                              <CheckCircle className="w-4 h-4" />
                            </Button>
                          )}
                          {doctor.account_status !== 'suspended' && (
                            <Button variant="ghost" size="sm" onClick={() => handleStatusChange(doctor._id, 'suspended')} className="text-red-600">
                              <Ban className="w-4 h-4" />
                            </Button>
                          )}
                          <Button variant="ghost" size="sm" onClick={() => { setSelectedDoctor(doctor); setShowDeleteDialog(true); }} className="text-red-600" data-testid={`delete-doctor-${doctor._id}`}>
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
);
